<div class="premium-acceptance">
  <h1 class="premium-acceptance__title title_42" [innerHTML]="'START.PREMIUM_ACCEPTANCE.TITLE' | translate"></h1>
  <p class="premium-acceptance__subtitle" [innerHTML]="'START.PREMIUM_ACCEPTANCE.SUBTITLE' | translate"></p>

  <div class="premium-acceptance__benefits">
    <h3 class="premium-acceptance__benefits-title" [innerHTML]="'START.PREMIUM_ACCEPTANCE.BENEFITS_HEADER' | translate"></h3>
    <ul class="premium-acceptance__benefits-list">
      <li>
        <img
          src="../../../../assets/svg/thick_v2.svg"
          class="premium-acceptance__check-icon"
          alt=""
          aria-hidden="true"
        />
        <span [innerHTML]="'START.PREMIUM_ACCEPTANCE.BENEFIT_1' | translate"></span>
      </li>
      <li>
        <img
          src="../../../../assets/svg/thick_v2.svg"
          class="premium-acceptance__check-icon"
          alt=""
          aria-hidden="true"
        />
        <span [innerHTML]="'START.PREMIUM_ACCEPTANCE.BENEFIT_2' | translate"></span>
      </li>
      <li>
        <img
          src="../../../../assets/svg/thick_v2.svg"
          class="premium-acceptance__check-icon"
          alt=""
          aria-hidden="true"
        />
        <span [innerHTML]="'START.PREMIUM_ACCEPTANCE.BENEFIT_3' | translate"></span>
      </li>
    </ul>
  </div>

  <p class="premium-acceptance__accept-text" [innerHTML]="'START.PREMIUM_ACCEPTANCE.ACCEPT_TEXT' | translate"></p>
  <p class="premium-acceptance__price" [innerHTML]="'START.PREMIUM_ACCEPTANCE.PRICE' | translate"></p>
</div>
